import { render, staticRenderFns } from "./setInformation.vue?vue&type=template&id=0a7b4ff2&scoped=true"
import script from "./setInformation.vue?vue&type=script&lang=js"
export * from "./setInformation.vue?vue&type=script&lang=js"
import style0 from "./setInformation.vue?vue&type=style&index=0&id=0a7b4ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b4ff2",
  null
  
)

export default component.exports